var app = angular.module("leonardo");

app.constant('AuthenticatedResolvers', {
  authData:['AuthDataService', '$rootScope', '$timeout', function(AuthDataService, $rootScope, $timeout) {
    if (isEmpty(AuthDataService.authData)) {
      return AuthDataService.getData().then(function (data) {
        $timeout(function () {
          $rootScope.$broadcast('auth-data:updated', data);
        }, 0);
      });
    }
  }]
});
